module.exports = __webpack_public_path__ + "static/image/history/pc/202406@3x.png?50b382d3";